export default "__VITE_ASSET__0c49dca4__"